import React , {useState , useEffect  ,useParams} from 'react'
import { useStore } from './store/comercioStore' ;
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Autocomplete from '@mui/material/Autocomplete';
import Snackbar from '@mui/material/Snackbar';
import { useNavigate } from "react-router-dom";

function EditComercio() {

    const { comercioId , tipo , asignaNom} = useStore();
    const [value, setValue] = React.useState(null);
    
       // const [nombredefantasia,setNombredefantasia] = useState('')
        const [calle,setCalle] = useState('');
        const [numero,setNumero] = useState('');
        const [socio, setSocio] = useState(false);
        const [cuit,setCuit] = useState('');
        const [razonsocial,setRazonsocial] = useState('');
        const [email,setEmail] = useState('');
        const [contacto,setContacto] = useState('');
        const [centrosComerciales,setCentrosComerciales] = useState([]);
        const [selectedOption, setSelectedOption] = useState(null);
        const [msgok,setMsgok] = useState(false); 
        const [msgno,setMsgno] = useState(false); 
        const [showAlert, setShowAlert] = useState(false);
        const navigate = useNavigate()       
        // funciones
        const handleOptionChange = (event, value) => {
          setSelectedOption(value);
        };

        const handleCloseAlert = (estado) => {
          setShowAlert(estado);
        };
        const handleChange = (event) => {
            setSocio(event.target.value);
          };
    
        const handleSubmit = async (event) => {
            event.preventDefault();
            const putData = {
              //  nombredefantasia : nombredefantasia,
                cuit : cuit,
                razonsocial : razonsocial,
                // idcentrocomercial : selectedOption === null ? value.idcentrocomercial : selectedOption.idcentrocomercial,
                // calle : calle,              numero : numero,
                email : email,
                contacto : contacto,
                socioucip : socio , // aprobacion : false , fecha_alta : new Date(), fecha_aprobacion : new Date(), detalle_aprobacion : ''
                idcomercio : comercioId
              };
                //
                try {
                    const baseURL = process.env.REACT_APP_SERVER_PATH + 'updateComercioData';
                    const res = await fetch(`${baseURL}`, {
                       
                      method: "PUT",
                      headers: {
                        "Content-Type": "application/json",
                        "x-access-token": "token-value",
                        'Access-Control-Allow-Origin': '*'
                      },
                      body: JSON.stringify(putData),
                    });
          
                    if (res.status === 200) {
                      setMsgok(true);
                
                      setCuit('');
                     // setRazonsocial('');
                      setCalle('');
                      setNumero('');
                      setEmail('');
                      setContacto('');
                      setSocio('');
                      setTimeout(() => {
                      volver(); 
                      }, 1000);
                      
                    } else
                    if (res.status === 401) 
                     {
                      //setMsgInfo(true);
                     }

                        } catch (err) {
              console.log(err.message)
                  }
                //
          };
          
          const volver = () => {
            if (tipo === '2') {
              navigate('/menuucip')
            }
            else 
             if (tipo === '3') {
              navigate('/menuCamaras')
            }
            else{
              asignaNom(razonsocial);
              navigate('/menucomercio')
            }
            
          }  
          const verificaCUIT =(campo) => {
            let aux = 0;
            let arreglo = campo.split('');
            for (let index = 0; index < arreglo.length-1; index++) {
              // eslint-disable-next-line
              switch (index) {
                 case 0:
                     aux += parseInt(arreglo[index]) * 5;
                 break;
                 case 1: 
                     aux += parseInt(arreglo[index]) * 4; 
                 break;
                 case 2: 
                     aux += parseInt(arreglo[index]) * 3; 
                 break;
                 case 3: 
                     aux += parseInt(arreglo[index]) * 2; 
                 break;
                 case 4: 
                     aux += parseInt(arreglo[index]) * 7; 
                 break;
                 case 5: 
                     aux += parseInt(arreglo[index]) * 6; 
                   break;
                 case 6: 
                     aux += parseInt(arreglo[index]) * 5; 
                 break;
                 case 7: 
                     aux += parseInt(arreglo[index]) * 4; 
                 break;    
                 case 8: 
                     aux += parseInt(arreglo[index]) * 3; 
                 break;
                 case 9:
                     aux += parseInt(arreglo[index]) * 2; 
                    break;
             } 
            } //for
         aux = (aux % 11);
         // eslint-disable-next-line
         if ((11-aux != arreglo[10] && aux !=0) || (arreglo.length !== 11)) // && arreglo.length !== 0)
              {setShowAlert(true)}
         else 
              {setShowAlert(false)}
          } 

          const getComercio = () => {
            const baseURL = process.env.REACT_APP_SERVER_PATH+'getComercio/'+comercioId;
            fetch(`${baseURL}`)
            .then(res => res.json())
            .then(
              (result) => { 
                 // setear todos los estados
                
                 setCuit(result[0].cuit);
                 setRazonsocial(result[0].razonsocial);
                 setValue({idcentrocomercial: result[0].idcentrocomercial,descripcion: result[0].descripcion}); 
                 setCalle(result[0].calle);
                 setNumero(result[0].numero);
                 setEmail(result[0].email);
                 setContacto(result[0].contacto);
                 setSocio(result[0].socioucip);
              },
              (error) => {
              }
            )
           }
          const getCentrosComerciales = () => {
            const baseURL = process.env.REACT_APP_SERVER_PATH+'getCentrosComerciales';
            fetch(`${baseURL}`)
            .then(res => res.json())
            .then(
              (result) => { setCentrosComerciales(result) 
              },
              (error) => {
              }
            )
           }

          useEffect( () => {
            //getCentrosComerciales() ; 
            getComercio();
            
             // eslint-disable-next-line react-hooks/exhaustive-deps         
        },[])
  return (
    <div>
    <Container component="main" maxWidth="md">
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }}>
        <h1>Actualización de mis datos</h1>
            <Grid container spacing={2}>
 {/*
                <Grid item xs={8} >
                    <TextField
                    autoComplete="given-name"
                    name="calle"
                    required
                    fullWidth
                    id="calle"
                    label="Calle"
                    value = {calle}
                    onChange = {(e) => setCalle(e.target.value)}
                    helpertext ="Campo requerido"
                    />
                </Grid>
               
                <Grid item xs={4} >
                    <TextField
                    autoComplete="given-name"
                    name="numero"
                    required
                    fullWidth
                    id="numero"
                    label="número"                  
                    type="number"
                    value = {numero}
                    onChange = {(e) => setNumero(e.target.value)}
                    helpertext ="Campo requerido"
                /> 
                </Grid>*/}
                <Grid item xs={12} >
                <TextField
                    name="cuit"
                    required 
                    fullWidth
                    id="cuit"
                    label="CUIT"
                    type="number"
                    value = {cuit}
                    onChange = {(e) => setCuit(e.target.value)}
                    helpertext ="Campo requerido"
                    onBlur= {() => verificaCUIT(cuit)}
                    />
                    {showAlert && (
                                 <Alert severity="warning" variant='filled' onClose={handleCloseAlert}>
                  <AlertTitle>CUIT incorrecto</AlertTitle>
                    verifíquelo</Alert> 
                    )}
                </Grid>

                <Grid item xs={12} >
                    <TextField
                    autoComplete="given-name"
                    name="razonsocial"
                    required
                    fullWidth
                    id="razonsocial"
                    label="Razón social"
                    value = {razonsocial}
                    onChange = {(e) => setRazonsocial(e.target.value)}
                    helpertext ="Campo requerido"
                    />
                </Grid>
                <Grid item xs={12}>

      </Grid>

                <Grid item xs={12}>
                    <TextField
                    required
                    fullWidth
                    id="email"
                    label="Correo Electrónico"
                    name="email"
                    autoComplete="email"
                    type = "email"
                    value = {email}
                    onChange = {(e) => setEmail(e.target.value)}
                    helpertext ="Campo requerido"
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                    required
                    fullWidth
                    id="contacto"
                    label="Contacto"
                    name="contacto"
                    autoComplete="Nombre Contacto"
                    type = "text"
                    value = {contacto}
                    onChange = {(e) => setContacto(e.target.value)}
                    helpertext ="Campo requerido"
                    />
                </Grid>                
                <Grid item xs={12}>
                <InputLabel id="simple-select-label">¿Es Socio?</InputLabel>
                    <Select
                   
                    required
                    fullWidth
                        labelId="simple-select-label"
                        value={socio}
                        label="socio"
                        onChange={handleChange}
                    >
                        <MenuItem value = { true }>SI</MenuItem>
                        <MenuItem value = { false }>NO</MenuItem>
                       
                    </Select>
                 
                </Grid>
            </Grid>
            <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            >
            Actualizar
            </Button>
            <Button
            color="secondary"
            onClick={volver}
            fullWidth
            variant="contained"
            sx={{ mt: 2, mb: 2 }}
            >
            CANCELAR
            </Button>
            <Snackbar open = {msgok} autoHideDuration={1000} onClose={ ()=> setMsgok(false)}>
                <Alert severity="success" variant='filled'>
                  <AlertTitle>Modificación Correcta</AlertTitle>
                    Hecho</Alert>
             </Snackbar>

        </Box>
    </Container>
</div>
  )
}

export default EditComercio